<template>
    <vx-tooltip
        v-if="tooltip"
        :color="dynamicPopoverColor"
        :text="tooltip"
        :position="tooltipPosition"
        delay=".1s"
        class="tooltip vx-action-icon"
    >
        <vx-basic-icon
            v-on="$listeners"
            :icon="dynamicIcon"
            class="custom-action-icon"
            :class="[
                { disabled: disabled },
                { active: active },
                { grow: growWhenActive },
                { spin: spin }
            ]"
            :size="size"
            :filled="filled"
            :rounded="rounded"
            :color="dynamicColor"
            @mouseover="hovered = true"
            @mouseleave="hovered = false"
        />
    </vx-tooltip>
    <vx-basic-icon
        v-else
        v-on="$listeners"
        :icon="dynamicIcon"
        class="custom-action-icon vx-action-icon"
        :class="[
            { disabled: disabled },
            { active: active },
            { grow: growWhenActive },
            { spin: spin }
        ]"
        :size="size"
        :filled="filled"
        :rounded="rounded"
        :color="dynamicColor"
        @mouseover="hovered = true"
        @mouseleave="hovered = false"
    />
</template>

<script>
export default {
    name: 'vx-action-icon',
    props: {
        tooltip: {
            type: String
        },
        tooltipPosition: {
            type: String,
            default: 'top'
        },
        icon: {
            type: String,
            required: true
        },
        hoverIcon: {
            type: String
        },
        activeIcon: {
            type: String
        },
        disabled: {
            type: Boolean,
            default: false
        },
        rounded: {
            type: Boolean,
            default: false
        },
        size: {
            type: [Number, String],
            default: 6
        },
        active: {
            type: Boolean,
            default: false
        },
        color: {
            type: String,
            default: 'dark'
        },
        hoverColor: {
            type: String
        },
        activeColor: {
            type: String
        },
        growWhenActive: {
            type: Boolean,
            default: false
        },
        filled: {
            type: Boolean,
            default: false
        },
        spin: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        icon: {
            handler: function (v) {
                this.parsedIcon = this.parseIcon(v)
            },
            immediate: true
        },
        hoverIcon: {
            handler: function (v) {
                this.parsedHoverIcon = this.parseIcon(v)
            },
            immediate: true
        },
        activeIcon: {
            handler: function (v) {
                this.parsedActiveIcon = this.parseIcon(v)
            },
            immediate: true
        }
    },
    data() {
        return {
            hovered: false,
            parsedHoverIcon: '',
            parsedActiveIcon: '',
            parsedIcon: ''
        }
    },
    computed: {
        dynamicIcon() {
            if (this.hovered && this.hoverIcon) {
                return this.parsedHoverIcon
            } else if (this.active && this.activeIcon) {
                return this.parsedActiveIcon
            }
            return this.parsedIcon
        },
        dynamicColor() {
            if (this.hovered && this.hoverColor) {
                return this.hoverColor
            } else if (this.active && this.activeColor) {
                return this.activeColor
            }
            return this.color
        },
        dynamicPopoverColor() {
            if (this.active && this.activeColor) {
                return this.activeColor
            }
            return this.hoverColor || this.color
        }
    },
    methods: {
        parseIcon(iconName) {
            if (iconName) {
                var pascalIcon = iconName.toPascalCase()
                if (pascalIcon.startsWith('Icon')) {
                    var parsedIconName = pascalIcon.substring(4, pascalIcon.length)
                    return `${parsedIconName}Icon`
                }
                return pascalIcon
            }
            return ''
        }
    }
}
</script>

<style scoped lang="scss">
.feather-icon ::v-deep svg {
    padding: 0;
    transition-delay: 0s;
    transition-duration: 0.25s;
    transition-property: all;
    transition-timing-function: ease-out;
    stroke-width: 2px !important;
    user-select: none;
}
.tooltip {
    height: 22px !important;
    transition: all 0.3s ease;
}

.custom-action-icon {
    cursor: pointer;
    transition: transform 0.2s ease;
    transform: scale(1.2);

    &.disabled {
        opacity: 0.3;
        pointer-events: none;
    }
    &:hover {
        transform: scale(1.4);
    }
    &.active.grow {
        transform: scale(1.8);

        &:hover {
            transform: scale(1.6);
        }
    }
}

.spin {
    animation: spin-animation 0.5s infinite;
    display: inline-block;
}

@keyframes spin-animation {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(359deg);
    }
}
</style>
